import { BusinessRulePredicate } from './../model/business-rules.model';
export function buildPredicateOperators(predicates?: BusinessRulePredicate[]) {
  const predicateOperators = [];

  if (predicates?.length > 1) {
    for (let i = 0; i < predicates.length; i++) {
      const firstPredicate = predicates[i],
        secondPredicate = predicates[i + 1];

      if (secondPredicate) {
        predicateOperators.push({
          firstPredicate,
          secondPredicate,
          operator: 'and',
        });
      }
    }
  }

  return predicateOperators;
}
